import { render, staticRenderFns } from "./BlogRegisterDialog.vue?vue&type=template&id=4810e15c"
import script from "./BlogRegisterDialog.vue?vue&type=script&lang=js"
export * from "./BlogRegisterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports